import { createFileRoute } from "@tanstack/react-router";
import { AccountSetupScreen } from "@modules/account-setup/views";

interface AccountSetupSearch {
  /** The one-time token of the emailed link. Absent renders the "no usable link" state. */
  token?: string;
}

/**
 * `/account-setup`: the landing path of the emailed setup link (the President's first setup, and
 * an Administrator's invitation). The path is NOT a choice: the backend builds the link as
 * `{IDENTITY_PUBLIC_BASE_URL}/account-setup?token=...`, so this route has to match it exactly.
 *
 * PUBLIC, deliberately: no `beforeLoad` guard. The recipient has no account until they submit
 * the form, so a guard would turn away the only people who belong here.
 */
export const Route = createFileRoute("/account-setup")({
  validateSearch: (search: Record<string, unknown>): AccountSetupSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: AccountSetupRoute,
});

function AccountSetupRoute() {
  const { token } = Route.useSearch();
  return <AccountSetupScreen tokenFromUrl={token} />;
}
